import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import API_URL from '../BaseUrl/BaseUrl';
import API_URL from "../../ApiUrl/ApiUrl";

const Dashboard = () => {
  const [bookings, setBookings] = useState([]);

  // fetchBookings
  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await axios.get(`${API_URL}/bookings`);
        console.log(response.data)
        setBookings(response.data);
      } catch (error) {
        console.error('Error fetching bookings:', error);
      }
    };

    fetchBookings();
  }, [])


  // fetchCars
  const [cars, setCars] = useState([]);
  useEffect(() => {
   
    const fetchCars = async () => {
      try {
        const response = await axios.get(`${API_URL}/cars`);
        const newData= response.data
        setCars(newData);
      } catch (error) {
        console.error('Error fetching cars:', error);
      }
    };

    fetchCars();
  }, []);


  // fetchUsers
  const [users, setUsers] = useState([]);
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${API_URL}/users`);
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);

  const [contact, setContact] = useState([]);

  // fetchBookings
  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await axios.get(`${API_URL}/carbooks`);
        console.log(response.data)
        setContact(response.data);
      } catch (error) {
        console.error('Error fetching bookings:', error);
      }
    };

    fetchBookings();
  }, [])
  return (
    <div>
     <div className="content-wrapper pb-2 mb-0">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h3 className="m-0 text-dark">Dashboard</h3>
              </div>
              {/* /.col */}
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">Home</li>
                  <li className="breadcrumb-item active">Dashboard</li>
                </ol>
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-sm-3 col-md-3 mb-2">
                <div className="info-box py-4 shadow d-flex align-items-center">
                  <span className="info-box-icon bg-info elevation-1 d-flex align-items-center justify-content-center">
                    <i className="fas fa-truck text-white" />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Car</span>
                    <br />
                    <span className="info-box-number">{cars.length}</span>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-3 col-md-3 mb-2">
                <div className="info-box mb-3 py-4 shadow">
                  <span className="info-box-icon bg-success elevation-1">
                    <i className="fa fa-user-secret" />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Contact</span>
                    <br/>
                    <span className="info-box-number">{bookings.length}</span>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-3 col-md-3 mb-2">
                <div className="info-box mb-3 py-4 shadow">
                  <span className="info-box-icon bg-warning elevation-1">
                    <i className="fa fa-user text-white" />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total User</span>
                    <br/>
                    <span className="info-box-number">{users.length} </span>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-3 col-md-3 mb-2">
                <div className="info-box mb-3 py-4 shadow">
                  <span className="info-box-icon bg-danger elevation-1">
                    <i className="fas fa-id-card" />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Booking</span>
                    <br/>
                    <span className="info-box-number">{contact.length}</span>
                  </div>
                </div>
              </div>
            </div>
      
          </div>
        </section>

        <div className="content-wrapper pb-2 mb-0 mt-4">
    <div className="content-header ">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h3 className="m-0 text-dark">latest  Booking </h3>
          </div>
         
        </div>
        {/* /.row */}
      </div>
      {/* /.container-fluid */}
    </div>
    {/* Main content */}
    <section className="content">
    <div className="container-fluid">
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table id="custtbl" className="table card-table table-vcenter">
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr className="bookingtable">
                  <th className="w-1">S. No.</th>
                  <th className="w-1">First Name</th>
                  <th>Last Name</th>
                  <th>Phone Number</th>
                  <th>Email</th>
                  <th>Address</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Vehicle</th>
                </tr>
              </thead>
              <tbody className="bookingtable" style={{ whiteSpace: "nowrap" }}>
                {bookings.length > 0 ? (
                  bookings.map((booking, index) => (
                    <tr key={booking._id}>
                      <td>{index + 1}</td>
                      <td>{booking.first_name}</td>
                      <td>{booking.last_name}</td>
                      <td>{booking.phone_number}</td>
                      <td>{booking.email}</td>
                      <td>{booking.address}</td>
                      <td>{new Date(booking.start_date).toLocaleDateString()}</td>
                      <td>{new Date(booking.end_date).toLocaleDateString()}</td>
                      <td>{booking.vehicle_type}</td>
                     
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center">No bookings available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    </section>
 
 {/* pagination */}
 <nav aria-label="Page navigation example">
  <ul className="pagination mt-4 float-end">
    <li className="page-item">
      <a className="page-link" href="#">
        Previous
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        1
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        2
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        3
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        Next
      </a>
    </li>
  </ul>
</nav>
  </div>
      </div>
    </div>
  )
}

export default Dashboard
